import React from 'react';

/**
 * The logo cross as an SVG. The "✝" character is drawn as a colour emoji on
 * phones, so the shape is drawn here to look the same on every device.
 */
export default function BrandCross() {
  return (
    <span className="brand-cross" aria-hidden="true">
      <svg viewBox="0 0 18 26" fill="currentColor" focusable="false">
        <path d="M7.6 0h2.8l-.3 1.2v5.5h5.7L17 6.4v3.2l-1.2-.3h-5.7V24.5l.3 1.5H7.6l.3-1.5V9.3H2.2L1 9.6V6.4l1.2.3h5.7V1.2z" />
      </svg>
    </span>
  );
}
